export class GlobalConstants {
  static sampleJSON = {
    user: {
      id: 42,
      name: { first: 'Sinta', last: 'Wijaya' },
      emails: ['sinta@example.com', 'wijaya@example.org'],
      address: {
        city: 'Yogyakarta',
        geo: { lat: -7.7956, lng: 110.3695 },
      },
    },
    orders: [
      {
        id: 'INV-1001',
        total: 129000,
        items: [
          {
            sku: 'A1',
            qty: 1,
          },
          {
            sku: 'B2',
            qty: 2,
          },
        ],
      },
      {
        id: 'INV-1002',
        total: 89000,
        items: [
          {
            sku: 'C3',
            qty: 3,
          },
        ],
      },
    ],
    active: true,
  };
}
